import { EntryStatus } from '@/components/entry-card';
import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';

// Predictions shows cashed-out entries as sold positions; every other product/status maps through.
export const useSbkEntryStatus = <T extends EntryStatus | undefined>(status: T): EntryStatus | T =>
    useIsPredictionsProduct() && status === EntryStatus.CashedOut ? EntryStatus.Sold : status;
